import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SupportPopupMainComponent } from './support-popup-main/support-popup-main.component';
import { SupportArticlePopupComponent } from './support-article-popup/support-article-popup.component';
import { TranslateHandler } from 'src/app/common/helpers/translate-handler';
import { TranslateModule } from '@ngx-translate/core';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { AuthorLabelPipe } from './pipes/author-label.pipe';
import { SupportContactusPopupComponent } from './support-contactus-popup/support-contactus-popup.component';
import { SupportTabComponent } from './support-tab/support-tab.component';
import { FaceRatingComponent } from 'src/app/shared/face-rating/face-rating.component';
import { EmailMessageComponent } from 'src/app/shared/email-message/email-message.component';
import { OsloDatePipe } from 'src/app/pipes/oslo-date.pipe';

@NgModule({
  declarations: [SupportPopupMainComponent, SupportArticlePopupComponent, SafeUrlPipe, AuthorLabelPipe, SupportContactusPopupComponent, SupportTabComponent],
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, FaceRatingComponent, EmailMessageComponent, OsloDatePipe],
  providers: [TranslateHandler],
  exports: [SupportPopupMainComponent, SupportArticlePopupComponent, SafeUrlPipe, SupportTabComponent]
})
export class SupportPopupModule { }
